import React from 'react'
import { Cookies } from 'react-cookie'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Home from './Home'
import Category from './Category'
import Report from './Report'
import Profile from './Profile'
import Editor from './Editor'
import Settings from './Settings'
import Manage from './Manage'
import Search from './Search'
import Reset from './Reset'
import ScrollTop from '../utility/ScrollTop'
import RequireAuth from '../components/Require_Auth'
import '../css/framework.min.css'
import '../css/react.css'
import configureStore from '../configureStore'
import { AUTH_USER } from '../constants/ActionTypes'

const store = configureStore()

let cookies = new Cookies()
let token = cookies.get('token')

if (token) {
	store.dispatch({
		type: AUTH_USER,
		response: {
			data: {
				token: cookies.get('token'),
				user_id: cookies.get('user_id'),
				user_img: cookies.get('user_img'),
				username: cookies.get('username')
			}
		}
	});
}

class Root extends React.Component {

	render() {
		
		return (
			<Provider store={store}>
				<Router>
					<ScrollTop>
						<Route exact path="/" component={Home} />
						<Route path="/category/:category_id" component={Category} />
						<Route path="/report/:report_id" component={Report} />
						<Route path="/profile/:profile_id/:type?" component={Profile} />
						<Route path="/editor/:type/:report_id?" component={RequireAuth(Editor)} />
						<Route path="/settings" component={RequireAuth(Settings)} />
						<Route path="/manage" component={Manage} />
						<Route path="/search" component={Search} />
						<Route path="/reset/:token?" component={Reset} />
					</ScrollTop>
				</Router>
			</Provider>
		)
	}
}

export default Root


// WEBPACK FOOTER //
// ./src/containers/Root.js